// src/components/Settings.js
import React from 'react';
import './Settings.css';

const Settings = () => {
  return (
    <div className="settings-container">
      <h2>Settings</h2>
      <p>Update your settings here.</p>
    </div>
  );
};

export default Settings;
